/* eslint-disable @typescript-eslint/no-explicit-any */
import { NuxtHTTPInstance } from '@nuxt/http';
import { Context } from '@nuxt/types';
import { useContext } from '@nuxtjs/composition-api';
import { NuxtCookies } from 'cookie-universal-nuxt';

import { UA } from '@/node_modules/nuxt-user-agent/lib/types';

export interface RainbowContext extends Context {
  $ua: UA;
  $http: NuxtHTTPInstance;
  $cookies: NuxtCookies;
  canUseWebp: () => boolean;
}

export type RainbowMiddleware = string | ((ctx: RainbowContext, cb: Function) => Promise<void> | void);

export function UseRainbowContext() {
  const nuxtContext = useContext();

  const canUseWebpClient = () => {
    const elem = document.createElement('canvas');

    if (!elem.getContext || !elem.getContext('2d')) return false;

    return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
  };

  const canUseWebpServer = () => {
    const headersAccepted = (nuxtContext as any).ssrContext.req.headers.accept;

    if (typeof headersAccepted === 'string') {
      return headersAccepted.split(',').includes('image/webp');
    }

    return false;
  };

  const canUseWebp = () => {
    if (!process.client) return canUseWebpServer();

    return canUseWebpClient();
  };

  return {
    ...nuxtContext,
    $ua: (nuxtContext as any).$ua as UA,
    $cookies: (nuxtContext as any).$cookies as NuxtCookies,
    $http: (nuxtContext as any).$http as NuxtHTTPInstance,
    canUseWebp,
  };
}
